<template lang="pug">
	.categories(data-aos="fade-up" data-aos-delay="200")
		router-link.categories__item(v-if="$route.name.toLowerCase() === 'news' || $route.name.toLowerCase() === 'promos'" to="/news/" :class="{'categories__item_active': $route.name.toLowerCase() === 'news'}") Новини
		router-link.categories__item(v-if="$route.name.toLowerCase() === 'news' || $route.name.toLowerCase() === 'promos'" to="/promos/" :class="{'categories__item_active': $route.name.toLowerCase() === 'promos'}") Акції
		router-link.categories__item(v-if="$route.name.toLowerCase() === 'articles' || $route.name.toLowerCase() === 'fieldnews'" to="/articles/" :class="{'categories__item_active': $route.name.toLowerCase() === 'articles'}") Публікації
		router-link.categories__item(v-if="$route.name.toLowerCase() === 'articles' || $route.name.toLowerCase() === 'fieldnews'" to="/field-news/" :class="{'categories__item_active': $route.name.toLowerCase() === 'fieldnews'}") Польові новини
</template>

<script>

	export default {
		name: 'newsCategories',
		data: function(){
			return {

			}
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';
	
	.categories {
		float: right;
		margin-top: 12px;

		&__item {
			display: inline-block;
			vertical-align: top;
			margin-left: 18px;
			opacity: 1;
			transition: opacity .5s ease;
			background-color: #fff;
			padding: 7px 30px;

			&:nth-child(1) {
				padding: 7px 22px;
			}

			&:nth-child(2) {
				padding: 7px 25px;
			}

			&:nth-child(3) {
				padding: 7px 27px;
				margin-left: 19px;
			}

			&_active {
				background-color: #EF3E33;
				color: #fff;
			}

			@media screen and (min-width: 1201px) {
				&:hover {
					opacity: .7;
					transition: opacity .3s ease;
				}
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.categories {
			float: none;
			width: 100%;
			display: flex;
			justify-content: flex-end;
			align-items: flex-start;
			margin: 39px 0 34px;

			&__item {
				margin-left: 15px;
				white-space: nowrap;
				
				padding: 7px 12px;

				&:nth-child(1) {
					padding: 7px 12px;
				}

				&:nth-child(2) {
					padding: 7px 16px;
				}

				&:nth-child(3) {
					margin-left: 0;
					padding: 7px 12px;
				}
			}
		}
	}


</style>
